/**
 * Homepage-only bundle. Enqueued exclusively on the front page
 * (see inc/enqueue.php — is_front_page() check), so no other page pays
 * the cost of ScrollSmoother/ScrollTrigger-heavy code.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { prefersReducedMotion } from './utils/motion.js';
import { initHeroInk } from './animations/hero-ink.js';
//import { initHeroBackground } from './animations/hero-bg.js';
import { initRegistrationMark } from './animations/registration-mark.js';
import { initPressSheets } from './animations/press-sheets.js';
import { initPrinter3D } from './animations/printer-3d.js';
import { initPortfolioUnroll } from './animations/portfolio-unroll.js';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


function initRainbowText() {
  const colors = ['8f2a46', 'ef85a3', 'f2a2b9', 'f7bfcf', 'fdd7e2', 'fee7ee'];
    //'ecb22a', 'ec6e2a', 'ec3a2a', 'ec2adc', '5a2aec', '2a4aec', '2ab2ec', '2aecc2', '2aec41', 'ccec2a'];
  const rainbowElements = document.querySelectorAll('.rainbow-text');
  
  rainbowElements.forEach(element => {
    // Get the text content (including any child elements)
    const text = element.textContent.trim();
    if (!text) return;
    
    // Split into individual characters and wrap each in a span
    element.innerHTML = text.split('').map((char, index) => {
      if (char === ' ') {
        return ' ';
      }
      const color = colors[index % colors.length];
      return `<span style="color: #${color};">${char}</span>`;
    }).join('');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('home')) return;

  initRainbowText();

  // Buttery inertia scrolling — wraps #smooth-wrapper/#smooth-content
  // (markup provided in front-page.php). Skipped entirely for reduced motion.
  if (!prefersReducedMotion()) {
    ScrollSmoother.create({
      wrapper: '#smooth-wrapper',
      content: '#smooth-content',
      smooth: 1.2,
      effects: true,
      normalizeScroll: true,
    });
  }

  initHeroInk(gsap);
  //initHeroBackground(gsap, ScrollTrigger);
  initRegistrationMark(gsap, ScrollTrigger);
  initPressSheets(gsap, ScrollTrigger);
  initPrinter3D();
  initPortfolioUnroll(gsap, ScrollTrigger);

  // Recalculate pin/scrub distances once images/webfonts finish loading
  window.addEventListener('load', () => ScrollTrigger.refresh());
});
